import { getPrefixRoute } from "../../../RBACPlugin";
import { getPrefixRouteDashboard } from "../../../RBACPlugin/services/utils/prefix-route-dashboard-util";


const DASHBOARD_SERVICE_BASE_URL = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/dashboard"
const DASHBOARD_USER_SERVICE_BASE_URL = process.env.REACT_APP_EID_ADMIN_API_ENDPOINT + "/api/v1/dashboard"
const DASHBOARD_ORG_NAME_BASE_URL = process.env.REACT_APP_EID_ADMIN_API_ENDPOINT + "/api/v1/organization";
const BOOKING_NAME_BY_PURPOSE_BASE_URL = process.env.REACT_APP_SBMA_APPOINTMENT_API_ENDPOINT + "/api/v1/booking";

const DASHBOARD_API_ENDPOINT = getPrefixRouteDashboard(DASHBOARD_SERVICE_BASE_URL) + "/dashboard";
const ADMIN_DASHBOARD_API_ENDPOINT = getPrefixRoute(DASHBOARD_USER_SERVICE_BASE_URL) + "/dashboard";


export default {

    COUNT_GATEPASS:       DASHBOARD_SERVICE_BASE_URL + "/gatepass",
    COUNT_VEHICLE:         DASHBOARD_SERVICE_BASE_URL + "/vehicle",
    COUNT_BOOKING:          DASHBOARD_SERVICE_BASE_URL + "/booking",
    COUNT_ACCESS_LOGS:    DASHBOARD_SERVICE_BASE_URL   + "/vehicle/accesslogs",
    COUNT_CONTAINER:     DASHBOARD_SERVICE_BASE_URL + "/container",


    COUNT_USER:             DASHBOARD_USER_SERVICE_BASE_URL + "/users/count",

    BOOKING_ANALYTICS:      DASHBOARD_SERVICE_BASE_URL + "/booking/component",
    GATEPASS_ANALYTICS:     DASHBOARD_SERVICE_BASE_URL + "/gatepass/component",
    VEHICLE_ANALYTICS:      DASHBOARD_SERVICE_BASE_URL + "/vehicle/component",
    CONTAINER_ANALYTICS:    DASHBOARD_SERVICE_BASE_URL + "/container/component",
    GET_ORG_NAME_BY_ORGUID: DASHBOARD_ORG_NAME_BASE_URL + "/orgnames",
    BOOKING_NAME_BY_PURPOSE: BOOKING_NAME_BY_PURPOSE_BASE_URL + "/post-query/ids"

}
